<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <ul class="nav nav-pills row" role="tablist">
            <li class="nav-item col-4" role="presentation">
              <button
                class="btn nav-link active col-12"
                id="hourly-tab"
                role="tab"
                data-toggle="pill"
                data-target="#hourly"
                @click="changeTab('hourlyTab')">
                Hourly
              </button>
            </li>
            <li class="nav-item col-4" role="presentation">
              <button
                class="btn nav-link col-12"
                id="daily-tab"
                role="tab"
                data-toggle="pill"
                data-target="#daily"
                @click="changeTab('dailyTab')">
                Daily
              </button>
            </li>
            <li class="nav-item col-4" role="presentation">
              <button
                class="btn nav-link col-12"
                id="monthly-tab"
                role="tab"
                data-toggle="pill"
                data-target="#monthly"
                @click="changeTab('monthlyTab')">
                Monthly
              </button>
            </li>
          </ul>

          <div class="tab-content">

            <div>
              <h3>Stats for {{type}} range</h3>
              <a id="csvlink" :href="downloadLocation">CSV download</a>
            </div>

            <div
              class="tab-pane fade show active"
              id="hourly"
              role="tabpanel">
              <div class="row">
                <basic-line-chart
                    class="col-6"
                    v-if="hLoaded"
                    :chartdata="hourlyData.smsData"
                    :style="lineChartStyle"
                    :type="type"
                    title="SMS"
                />
                <basic-line-chart
                    class="col-6"
                    v-if="hLoaded"
                    :chartdata="hourlyData.mailData"
                    :style="lineChartStyle"
                    :type="type"
                    title="Mail"
                />
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="daily"
              role="tabpanel">
              <div class="row">
                <basic-line-chart
                    class="col-6"
                    v-if="dLoaded"
                    :chartdata="dailyData.smsData"
                    :style="lineChartStyle"
                    :type="type"
                    title="SMS"/>
                <basic-line-chart
                    class="col-6"
                    v-if="dLoaded"
                    :chartdata="dailyData.mailData"
                    :style="lineChartStyle"
                    :type="type"
                    title="Mail"
                />
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="monthly"
              role="tabpanel">
              <div class="row">
                <basic-line-chart
                    class="col-6"
                    v-if="mLoaded"
                    :chartdata="monthlyData.smsData"
                    :style="lineChartStyle"
                    :type="type"
                    title="SMS"/>
                <basic-line-chart
                    class="col-6"
                    v-if="mLoaded"
                    :chartdata="monthlyData.mailData"
                    :style="lineChartStyle"
                    :type="type"
                    title="Mail"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicLineChart from "@/components/chart/BasicLineChart";
import moment from 'moment';

import Api from "@/api/support"
import Vue from "vue";
import logs from "@/api/logs";
export default {
  name: "app-dashboard",
  components: {
    BasicLineChart
  },
  computed: {
    lineChartStyle() {
      return {
        width: '100%',
        height: '22rem',
        position: 'relative'
      }
    },
  },
  data() {
    return {
      hLoaded : false,
      dLoaded : false,
      mLoaded : false,
      type: 'hourly',
      tabList: {
        hourlyTab : {type: 'hourly', downloadLocation: '/assets/document/hourly.csv'},
        dailyTab: {type: 'daily', downloadLocation: '/assets/document/daily.csv'},
        monthlyTab: {type: 'monthly', downloadLocation: '/assets/document/monthly.csv'},
      },
      options: {
        'totSent': {label: 'Total Sent', color: '#019875'},
        'rgrSmsSent': {label: 'Regular SMS Sent', color: '#0078ff'},
        'prmSmsSent': {label: 'Premium SMS Sent', color: '#6a8ed2'},
        'rgrMailSent': {label: 'Regular Mail Sent', color: '#9600ff'},
        'prmMailSent': {label: 'Premium Mail Sent', color: '#c590ea'},
        'totFail' : {label: 'Total Failure', color: '#d04848'},
        'smsFail': {label: 'SMS Failure', color: '#ffa500'},
        'mailFail': {label: 'Mail Failure', color: '#ff7400'}
      },
      downloadLocation: null,
      hourlyData: {
        smsData: {},
        mailData: {}
      },
      dailyData: {
        smsData: {},
        mailData: {}
      },
      monthlyData: {
        smsData: {},
        mailData: {}
      },
    }
  },
  created() {
    this.callAllApis();
  },
  methods: {
    changeTab(id){
      this.type = this.tabList[id].type;
      this.downloadLocation = this.tabList[id].downloadLocation;
    },
    activeClass(tab) {
      if (tab.type == this.type)
        return 'active';
    },
    callAllApis(){
      Vue.prototype.$loading(true);
      this.getHourly();
      this.getDaily();
      this.getMonthly();
    },
    getHourly() {
      var params = {};
      var start = moment().subtract(12, 'hours').format('YYYY-MM-DDTHH:00:00');
      var end = moment().subtract(1, 'hours').format('YYYY-MM-DDTHH:00:00');

      params.statsType = 'H';
      params.startDtm = start;
      params.endDtm = end;

      this.hLoaded = false;
      Api.getStats(params).then(({data})=> {
        if (data && data.code === 1000) {
          // this.$notify.success('Success');
          console.log('getHourly result: ', data);
          this.setData(this.hourlyData, data.content);
          console.log('hourlyData: ', this.hourlyData);
          this.hLoaded = true;

          this.createDataFile(data.content.statsType, this.hourlyData);

        }else if (!data || data.code !== 1000){
          this.$notify.error('Fail', data.message);
        }
      })
    },
    getDaily() {
      var params = {};
      var start = moment().subtract(7, 'days').format('YYYY-MM-DDT00:00:00');
      var end = moment().subtract(1, 'days').format('YYYY-MM-DDT00:00:00');

      params.statsType = 'D';
      params.startDtm = start;
      params.endDtm = end;

      this.mLoaded = false;
      Api.getStats(params).then(({data}) => {
        if (data && data.code === 1000) {
          // this.$notify.success('Success');
          console.log('getDaily result: ', data);
          this.setData(this.dailyData, data.content);
          console.log('DailyData: ', this.dailyData);
          this.dLoaded = true;

          this.createDataFile(data.content.statsType, this.dailyData);

        } else if (!data || data.code !== 1000){
          this.$notify.error('Fail', data.message);
        }
      })
    },
    getMonthly() {
      var params = {};
      var start = moment().subtract(6, 'months').format('YYYY-MM-DDT00:00:00');
      var end = moment().subtract(1, 'months').format('YYYY-MM-DDT00:00:00');

      params.statsType = 'M';
      params.startDtm = start;
      params.endDtm = end;

      this.mLoaded = false;
      Api.getStats(params).then(({data}) => {
        if (data && data.code === 1000) {
          // this.$notify.success('Success');
          console.log('getMonthly result: ', data);
          this.setData(this.monthlyData, data.content);
          console.log('MonthlyData: ', this.monthlyData);
          this.mLoaded = true;

          this.createDataFile(data.content.statsType, this.monthlyData);

        } else if (!data || data.code !== 1000){
          this.$notify.error('Fail', data.message);
        }
      })
    },

    convertResDtm(type, dtm) {
      switch (type) {
        case "H":
          return moment(dtm).hour();
        case "D":
          return moment(dtm).format('DD MMM YYYY')
        case "M":
          return moment(dtm).format('MMM YYYY')
      }
    },
    setData(data, content) {
      for (let index in content.rangeDtm) {
        content.rangeDtm[index] = this.convertResDtm(content.statsType, content.rangeDtm[index]);
      }
      data.smsData.labels = data.mailData.labels = content.rangeDtm;

      const entries = Object.entries(content);
      const smsRes = entries.filter(t => t[0].includes('sms') || t[0].includes('Sms') );
      const mailRes = entries.filter(t => t[0].includes('mail') || t[0].includes('Mail') );

      data.smsData.datasets = [];
      data.mailData.datasets = [];
      smsRes.forEach(([key, value]) => {
        let obj = {};
          obj.fill = false;
          obj.label = this.options[key].label;
          obj.data = value;
          obj.borderColor = this.options[key].color;
          obj.backgroundColor = this.options[key].color;
          obj.lineTension = 0;
          data.smsData.datasets.push(obj);
      });
      mailRes.forEach(([key, value]) => {
        let obj = {};
        obj.fill = false;
        obj.label = this.options[key].label;
        obj.data = value;
        obj.borderColor = this.options[key].color;
        obj.backgroundColor = this.options[key].color;
        obj.lineTension = 0;
        data.mailData.datasets.push(obj);
      });

    },

    createDataFile(statsType, obj) {
      let total = {};
      total.labels = [...obj.smsData.labels];
      total.datasets = [...obj.smsData.datasets, ...obj.mailData.datasets];

      //write Dtm
      let dataString = "\t,";
      total.labels.forEach(label => dataString += label + "," );
      dataString = dataString.slice(0,-1);
      dataString += '\r\n';

      //map -> [ [label,data[0],data[1]...], [], []... ]
      const mappedTotal = total.datasets.map(dataset => {
        const {label, data} = dataset;
        return [label, ...data];
      });

      //write label,data
      mappedTotal.forEach(m => {
        dataString += m.reduce((acc, cur) => acc + ',' + cur);
        dataString += "\r\n";
      });

      let downloadLink = document.getElementById('csvlink');
      let blob = new Blob([dataString], {type:"text/csv;charset=utf-8"});
      let url = URL.createObjectURL(blob);

      switch (statsType){
        case 'H':
          this.tabList["hourlyTab"].downloadLocation = url;
          this.downloadLocation = url;
          break;
        case 'D':
          this.tabList["dailyTab"].downloadLocation = url;
          break;
        case 'M':
          this.tabList["monthlyTab"].downloadLocation = url;
          break;
      }
      downloadLink.download =  "Dashboard_Data.csv";
    }
  }
}
</script>

<style scoped>
.btn {
  padding: 3px 24px;
  margin: 0px 5px;
  border: 0 none;
  font-weight: 700;
  letter-spacing: 1px;
  border-radius: 0;
  background: #A6A6A6;
  color: #ffffff;
}

.btn:hover, .btn:focus, .btn:active, .btn.nav-link.active{
	background: #00B0F0;
}

h3 {
    font-weight: bold;
    display: inline;
    margin: 0 10px;
}
</style>
